import { BodyText } from '@postscript/components';
import { FeedbackPanel, FeedbackThumbs } from 'components/feedback';
import { useMessageFeedback } from 'components/sales/components/useMessageFeedback';
import { Message, Subscriber } from 'components/sales/types';
import React from 'react';
import styled from 'styled-components';

import { IDENTITY_COPY } from './copy';

const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const PanelWrap = styled.div`
  margin-top: var(--spacing-2);
`;

interface MessageFeedbackControlsProps {
  message: Message;
  subscriber: Subscriber | null;
}

// Wires the shared feedback affordance (the same one used in the conversation
// thread via MessageMetadata) into the Message Details Overview, so a merchant
// can rate the generated message from either surface against the same record.
export const MessageFeedbackControls: React.FC<MessageFeedbackControlsProps> =
  ({ message, subscriber }) => {
    const {
      canSubmitFeedback,
      feedbackDisplay,
      isLocked,
      showFeedbackPanel,
      panelFeedback,
      handleThumbsUp,
      handleThumbsDown,
      handleFeedbackPanelSubmit,
      handleFeedbackPanelClose,
    } = useMessageFeedback(message, subscriber);

    const identity = `${IDENTITY_COPY.shopperAutomation} • ${
      message.rcs_message ? 'RCS' : 'SMS'
    }`;

    if (!canSubmitFeedback) {
      return (
        <Footer>
          <BodyText size="small" color="var(--text-color-dim)">
            {identity}
          </BodyText>
        </Footer>
      );
    }

    return (
      <>
        <Footer>
          <FeedbackThumbs
            feedback={feedbackDisplay}
            disabled={isLocked}
            onThumbsUp={handleThumbsUp}
            onThumbsDown={handleThumbsDown}
          />
          <BodyText size="small" color="var(--text-color-dim)">
            {identity}
          </BodyText>
        </Footer>
        {showFeedbackPanel && (
          <PanelWrap>
            <FeedbackPanel
              messageId={message.sent_message_id.toString()}
              feedback={panelFeedback}
              onSubmit={handleFeedbackPanelSubmit}
              onClose={handleFeedbackPanelClose}
              showBrandCenterBanner
            />
          </PanelWrap>
        )}
      </>
    );
  };
